/**
 * Editor + preview visibility for popup schema sections.
 * Uses setting.customCSS.{desktop,mobile}.display (same as AI layout compat setVisibility).
 */

export function isSectionVisible(section) {
  if (!section) return false;
  const desktop = section?.setting?.customCSS?.desktop?.display;
  const mobile = section?.setting?.customCSS?.mobile?.display;
  if (desktop === "none" || mobile === "none") return false;
  return true;
}

/** Viewport-aware visibility for preview render (desktop vs mobile toolbar). */
export function isSectionVisibleForViewport(section, isMobile = false) {
  if (!section) return false;
  const view = isMobile ? "mobile" : "desktop";
  return section?.setting?.customCSS?.[view]?.display !== "none";
}

/** @returns {'flex'|'block'|'none'} */
export function resolveSectionVisibleDisplay(section, fallback = "flex") {
  const desktop = section?.setting?.customCSS?.desktop?.display;
  if (desktop && desktop !== "none") return desktop;
  return fallback;
}

export function setSectionVisibility(section, isVisible, visibleDisplay = "flex") {
  if (!section) return;
  section.setting = section.setting || {};
  section.setting.customCSS = section.setting.customCSS || {};
  const display = isVisible ? visibleDisplay : "none";
  section.setting.customCSS.desktop = {
    ...(section.setting.customCSS.desktop || {}),
    display,
  };
  section.setting.customCSS.mobile = {
    ...(section.setting.customCSS.mobile || {}),
    display,
  };
}
